import { addDays, eachDayOfInterval, endOfMonth, endOfWeek, format, startOfWeek } from 'date-fns';
import { WEEK_STARTS_ON } from '@/constants/app.constants';
import { formatDate } from '@/utils/date';

const DAYS_IN_WEEK = 7;
const SHORT_WEEKDAY_FORMAT = 'EEE';
const WEEK_OPTIONS = { weekStartsOn: WEEK_STARTS_ON } as const;

export interface MonthCalendarDay {
  isoDate: string;
  dayOfMonth: number;
  isInMonth: boolean;
}

export function getWeekdayLabels(): string[] {
  const weekStart = startOfWeek(new Date(), WEEK_OPTIONS);
  return Array.from({ length: DAYS_IN_WEEK }, (_, offset) =>
    format(addDays(weekStart, offset), SHORT_WEEKDAY_FORMAT),
  );
}

function toMonthCalendarDays(monthStart: Date, start: Date, end: Date): MonthCalendarDay[] {
  const monthEnd = endOfMonth(monthStart);
  return eachDayOfInterval({ start, end }).map((day) => ({
    isoDate: formatDate(day),
    dayOfMonth: day.getDate(),
    isInMonth: day >= monthStart && day <= monthEnd,
  }));
}

export function getMonthCalendarDays(monthStart: Date): MonthCalendarDay[] {
  return toMonthCalendarDays(
    monthStart,
    startOfWeek(monthStart, WEEK_OPTIONS),
    endOfMonth(monthStart),
  );
}

export function getMonthCalendarWeeks(monthStart: Date): MonthCalendarDay[][] {
  const days = toMonthCalendarDays(
    monthStart,
    startOfWeek(monthStart, WEEK_OPTIONS),
    endOfWeek(endOfMonth(monthStart), WEEK_OPTIONS),
  );
  return Array.from({ length: days.length / DAYS_IN_WEEK }, (_, week) =>
    days.slice(week * DAYS_IN_WEEK, (week + 1) * DAYS_IN_WEEK),
  );
}
